/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';
import { AdminCacheService } from '../../services/admin/admin-cache.service';
import { GlobalMessageService } from '../../services/global-message.service';


@Component({
  selector: 'app-admin-cache',
  templateUrl: './admin-cache.component.html',
  styleUrls: ['./admin-cache.component.scss']
})
export class AdminCacheComponent implements OnInit {

  loadingPage: boolean = false;
  lookupKey: string = '';
  cache: any[] = [];

  constructor(private modalService: BsModalService,
              private adminCacheService: AdminCacheService,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    this.search();
  }

  deleteAll() {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm that you'd like to purge ALL keys from cache.`,
        confirm: function() {
          me.adminCacheService.deleteAll().subscribe(
            (result: any) => {
              me.globalMessageService.message('Cache was cleared');
              me.lookupKey = '';
              me.search();
            },
            error => {
              console.error(error);
              me.globalMessageService.error(JSON.stringify(error));
            }
          )
        }
      }
    }));
  }

  deleteKey(key: string) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm that you'd like to purge '${key}' from cache.`,
        confirm: function() {
          me.adminCacheService.deleteKey(key).subscribe(
            (result: any) => {
              me.globalMessageService.message('Key was deleted');
              me.search();
            },
            error => {
              console.error(error);
              me.globalMessageService.error(JSON.stringify(error));
            }
          )
        }
      }
    }));
  }

  search() {
    this.loadingPage = true;
    let searchKey = this.lookupKey.length > 0 ? this.lookupKey : '*';
    this.adminCacheService.getKeysWithValues(searchKey).subscribe(
      (result: any) => {
        this.cache = result;
        this.cache.forEach(c => {
          c.show_detail = false;
        });
        this.loadingPage = false;
      },
      e => {

      }
    )
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-cache/admin-cache.component.ts